/** Avoid magic numbers by centralizing the role and level integers. */

var accessConstants = {
  data() {
    return {
      // - GroupAccess.ACCESS_ROLE_*
      GA_ACCESS_ROLE_STORE: 1,
      GA_ACCESS_ROLE_SPOT: 2,

      // GroupAccess and StoreAccess share the same values for level:
      // - GroupAccess.ACCESS_LEVEL_*
      // - StoreAccess.ACCESS_LEVEL_*
      GA_ACCESS_LEVEL_READ: 0,
      GA_ACCESS_LEVEL_FULL: 2,
    };
  },
};

export default accessConstants;



// WEBPACK FOOTER //
// ./src/mixins/accessConstants.js